module.exports = __webpack_public_path__ + "img/guide1.82c86ee3.jpg";